import * as SL from "./screen-link";
import * as SA from "./screen-anchor";

const DYNAMIC_LINKS = [SL.COUNTRY_LINK, SL.CITY_LINK, SL.DIVISION_LINK, SL.CATEGORY_LINK, SL.SERVICE_LINK];

const STATIC_LINKS = Object.values(SL).filter(link => !DYNAMIC_LINKS.includes(link));

export { SL, STATIC_LINKS, SA };